import styled from 'styled-components';

import {
  EmptyStateWrapper as BaseEmptyStateWrapper,
  HeaderText as BaseHeaderText,
  ImageWrapper as BaseImageWrapper,
} from './base';

export * from './base';

export const EmptyStateWrapper = styled(BaseEmptyStateWrapper)`
  margin-block-start: 25%;
`;

export const HeaderText = styled(BaseHeaderText)`
  font-size: 1.625rem;
`;

export const ImageWrapper = styled(BaseImageWrapper)`
  height: 7rem;
`;
